import { create } from "zustand";
import { axiosHelper, tokenHelper } from "./helpers";

export const useDashboardStore = create((set, get) => ({
  dailyStats: null,
  weeklyServices: [],
  weeklyOrders: [],
  dailyServiceStats: [],
  visitDaily: null,
  visitWeekly: null,
  visitSpaces: null,
  responseTimeStats: [],
  weeklyResponseTime: [],
  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading }),
  setDailyStats: (data) => set({ dailyStats: data }),
  setWeeklyServices: (data) => set({ weeklyServices: data }),
  setWeeklyOrders: (data) => set({ weeklyOrders: data }),

  fetchStats: async (siteIds, day) => {
    try {
      set({ isLoading: true });

      const accessToken = await tokenHelper.getToken();
      // If no sites selected, pass empty string to fetch all data
      const siteIdsString = (siteIds && siteIds.length > 0) ? siteIds.join(",") : "";

      // Fetch all endpoints in parallel
      const [
        dailyResponse,
        weeklyServicesResponse,
        weeklyOrdersResponse,
        dailyServiceOrdersResponse,
        visitDailyResponse,
        visitWeeklyResponse,
        visitSpacesResponse,
        visitKitchensResponse,
        responseTimeResponse,
        weeklyResponseTimeResponse,
      ] = await Promise.all([
        axiosHelper.get(
          `/order/stats/daily?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/order/stats/weekly/services?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/order/stats/weekly/orders?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/order/stats/daily/services/orders?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/visit-history/stats/daily?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/visit-history/stats/weekly?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/visit-history/stats/daily/spaces?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/visit-history/stats/daily/kitchens?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/order/stats/daily/services/response-time?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
        axiosHelper.get(
          `/order/stats/weekly/response-time?date=${day}&sites=${siteIdsString}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        ),
      ]);

      set({
        dailyStats: dailyResponse,
        weeklyServices: weeklyServicesResponse,
        weeklyOrders: weeklyOrdersResponse,
        dailyServiceStats: dailyServiceOrdersResponse,
        visitDaily: visitDailyResponse,
        visitWeekly: visitWeeklyResponse,
        visitSpaces: visitSpacesResponse,
        visitKitchens: visitKitchensResponse,
        responseTimeStats: responseTimeResponse || [],
        weeklyResponseTime: weeklyResponseTimeResponse || [],
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching stats:", error);
      set({ isLoading: false });
    }
  },
}));
